'use client'
import { type ReactNode, memo, useEffect } from 'react'
// import { usePathname } from 'next/navigation'
import styled from 'styled-components'
import { motion } from 'motion/react'
// import type { Variants } from 'motion/react'
// import type { TypeTransitionName } from '@/context'
// import { usePageTransition } from '@/hooks'
// import { getTransition } from '@/styles'

interface TransitionWrapperProps {
  children: ReactNode
}

// function getInitialVariantName(pathname: string): TypeTransitionName {
//   return pathname.includes('proposal') ? 'initialVisible' : 'initial'
// }

let firstLoad = true
export const TransitionWrapper = memo(({ children }: TransitionWrapperProps) => {
  // const pathname = usePathname()
  // const initial = useMemo(() => firstLoad ? 'initial' : getInitialVariantName(pathname), [pathname])
  // const { transitionName } = usePageTransition()

  useEffect(() => {
    if(firstLoad) firstLoad = false
  }, [])

  // key={0} variants={variants} initial={initial} animate={transitionName ?? 'animate'} exit='exit'
  return (
    <Div>
      {children}
    </Div>
  )
})

const Div = styled(motion.div)`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100vw;
  width: 100dvw;

  > main {
    flex-grow: 2;
  }
`

export const PAGE_FADE_OUT_DURATION = .2
export const PAGE_FADE_IN_DURATION = .5
// const variants:Variants = {
//   initial: {
//     opacity: 0,
//     transition: {
//       duration: PAGE_FADE_OUT_DURATION,
//     }
//   },
//   animate: {
//     opacity: 1,
//     transition: {
//       ...getTransition(),
//       duration: PAGE_FADE_IN_DURATION,
//     }
//   },
//   exit: {
//     opacity: 0,
//     transition: {
//       ...getTransition(),
//       duration: PAGE_FADE_OUT_DURATION
//     }
//   },
//   initialVisible: {
//     opacity: 1,
//     transition: {
//       duration: 0
//     }
//   }
// }
